import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const InvestorsPage = lazy(() => import('../pages/investors/page'));
const KitchensPage = lazy(() => import('../pages/products/kitchens/page'));
const FlooringPage = lazy(() => import('../pages/products/flooring/page'));
const WindowsDoorsPage = lazy(() => import('../pages/products/windows-doors/page'));
const ExteriorsPage = lazy(() => import('../pages/products/exteriors/page'));
const HardwarePage = lazy(() => import('../pages/products/hardware/page'));
const SteelBuildingPage = lazy(() => import('../pages/products/steel-building/page'));
const FurniturePage = lazy(() => import('../pages/products/furniture/page'));
const LightingPage = lazy(() => import('../pages/products/lighting/page'));
const PlumbingPage = lazy(() => import('../pages/products/plumbing/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPost1Page = lazy(() => import('../pages/blog/future-of-global-construction-supply-chains/page'));
const BlogPost2Page = lazy(() => import('../pages/blog/reduce-construction-material-costs/page'));
const BlogPost3Page = lazy(() => import('../pages/blog/navigating-international-customs/page'));
const BlogPost4Page = lazy(() => import('../pages/blog/sustainable-building-materials/page'));
const BlogPost5Page = lazy(() => import('../pages/blog/steel-buildings-commercial-construction/page'));
const BlogPost6Page = lazy(() => import('../pages/blog/quality-control-international-sourcing/page'));
const BlogPost7Page = lazy(() => import('../pages/blog/hospitality-furniture-sourcing/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPage = lazy(() => import('../pages/legal/privacy/page'));
const TermsPage = lazy(() => import('../pages/legal/terms/page'));
const CookiesPage = lazy(() => import('../pages/legal/cookies/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/investors',
    element: <InvestorsPage />,
  },
  {
    path: '/products/kitchens',
    element: <KitchensPage />,
  },
  {
    path: '/products/flooring',
    element: <FlooringPage />,
  },
  {
    path: '/products/windows-doors',
    element: <WindowsDoorsPage />,
  },
  {
    path: '/products/exteriors',
    element: <ExteriorsPage />,
  },
  {
    path: '/products/hardware',
    element: <HardwarePage />,
  },
  {
    path: '/products/steel-building',
    element: <SteelBuildingPage />,
  },
  {
    path: '/products/furniture',
    element: <FurniturePage />,
  },
  {
    path: '/products/lighting',
    element: <LightingPage />,
  },
  {
    path: '/products/plumbing',
    element: <PlumbingPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/future-of-global-construction-supply-chains',
    element: <BlogPost1Page />,
  },
  {
    path: '/blog/reduce-construction-material-costs',
    element: <BlogPost2Page />,
  },
  {
    path: '/blog/navigating-international-customs',
    element: <BlogPost3Page />,
  },
  {
    path: '/blog/sustainable-building-materials',
    element: <BlogPost4Page />,
  },
  {
    path: '/blog/steel-buildings-commercial-construction',
    element: <BlogPost5Page />,
  },
  {
    path: '/blog/quality-control-international-sourcing',
    element: <BlogPost6Page />,
  },
  {
    path: '/blog/hospitality-furniture-sourcing',
    element: <BlogPost7Page />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/legal/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/legal/terms',
    element: <TermsPage />,
  },
  {
    path: '/legal/cookies',
    element: <CookiesPage />,
  },
  {
    path: '/quote',
    lazy: async () => {
      const { default: Component } = await import('../pages/quote/page');
      return { Component };
    },
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;